<template>
  <div class="article-frame sup-page-frame">
    <div class="article-box sup-page-box">
      <img class="header-img" :src="$getThemeImagePath('sup/sup_faq_banner.jpg')" alt="よくある質問">
      <div class="content pos-relative">
        <go-to-top />
        <sup-menu />

        <h1 class="sup-page-title">
          よくある質問
        </h1>
        <div class="sup-wallet-index">
          <p class="sup-wallet-index-title">
            よくある質問の利用方法
          </p>
          <div class="sup-wallet-index-list">
            <a class="sup-wallet-index-btn" href="#faq-regist">
              <span>ご登録・ご利用について</span>
              <span class="sup-wallet-index-arrow"><svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L6 6L11 1" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg></span>
            </a>
            <a class="sup-wallet-index-btn" href="#faq-login">
              <span>ログイン・アカウントについて</span>
              <span class="sup-wallet-index-arrow"><svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L6 6L11 1" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg></span>
            </a>
            <a class="sup-wallet-index-btn" href="#faq-deposit">
              <span>入金について</span>
              <span class="sup-wallet-index-arrow"><svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L6 6L11 1" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg></span>
            </a>
            <a class="sup-wallet-index-btn" href="#faq-withdraw">
              <span>出金について</span>
              <span class="sup-wallet-index-arrow"><svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L6 6L11 1" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg></span>
            </a>
            <a class="sup-wallet-index-btn" href="#faq-game">
              <span>ゲームについて</span>
              <span class="sup-wallet-index-arrow"><svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L6 6L11 1" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg></span>
            </a>
            <a class="sup-wallet-index-btn" href="#faq-crypto">
              <span>仮想通貨について</span>
              <span class="sup-wallet-index-arrow"><svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L6 6L11 1" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg></span>
            </a>
          </div>
        </div>
        <div id="faq-regist" class="sup-faq-section">
          <p class="sup-faq-section-title">
            ご登録・ご利用について
          </p>
          <div class="sup-faq-list">
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">勝WINへの登録方法は？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">「新規登録」をクリックし、必要事項を入力すると登録が完了します。</span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">利用可能なデバイスは？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">勝WINはスマートフォン、タブレット、PCに対応しています。いつでもどこでもお楽しみいただけます。</span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">使用できる通貨は？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">法定通貨の日本円（JPY）に加えて、10種類以上の仮想通貨で入出金が可能です。<br>勝WINでは、以下の仮想通貨での入出金に対応しております：<ul class="sup-faq-ul"><li>USDT（テザー）</li><li>LTC（ライトコイン）</li><li>XRP（リップル）</li><li>BTC（ビットコイン）</li><li>ETH（イーサリアム）</li><li>DOGE（ドージコイン）</li><li>BCH（ビットコインキャッシュ）</li><li>TRX（トロン）</li><li>BNB（バイナンスコイン）</li><li>USDC（USDコイン）</li><li>SHIB（シバイヌ）</li><li>TETH（テセリウム）</li></ul></span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">年齢制限はありますか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">勝WINのご利用は、20歳以上の方に限られます。</span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">プレイ可能な地域は？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">コモロ諸島の法律に基づき、以下の国・地域にお住まいのお客様は、勝WINの口座開設およびご利用ができません。オーストラリア、オーストリア、コモロ諸島、フランス、ドイツ、オランダ、スペイン、英国、米国、ならびにFATFブラックリストに掲載されている国。</span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">登録アカウントで無料ゲームをプレイできますか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">新規登録されたお客様には、1回限りの入金不要ボーナスをご提供しています。</span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">アカウントはいくつ作成できますか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">お客様が公平かつ安心してご利用いただけるよう、アカウントはお一人様につき1つまでとなり、同一IP・同一デバイス・同一IPでの複数アカウント登録は不正行為とみなされます。規約に違反した場合、アカウントの停止、全てのキャンペーン参加資格の剥奪、ウォレット残高の没収などの措置を取らせていただく場合がございます。</span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">自宅以外のPCから利用できますか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">はい、ご利用いただけます。<br>ただし、公共のPCや他人が利用する端末でログインする場合は、アカウント情報の取り扱いに十分ご注意ください。<br>万一お客様のアカウントが不正に使用された場合、その損害について勝WINは責任を負いかねますので、あらかじめご了承ください。</span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">VPNを使ってプレイできますか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">いいえ。勝WINでは、VPNやプロキシサーバーを利用して実際の所在地を隠す行為を禁止しています。</span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">なぜ個人情報が必要ですか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">個人情報は、アカウントの正当性を確認し、規約を遵守するために必要です。<br>また、不正行為を防止し、お客様のアカウントを安全に守るためにも欠かせません。</span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">登録した個人情報は変更できますか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">ご登録いただいた個人情報は、お客様ご自身で変更することはできません。<br>変更が必要な場合は、カスタマーサポートまでお問い合わせください。</span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">ライブチャットが利用できません。どうすれば良いですか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">一時的に接続が不安定な可能性があります。時間をおいて再度お試しください。<br>解決しない場合は「<a href="/cdn-cgi/l/email-protection#cab9bfbabaa5b8be8aa1abbeb9bfbda3a4e4aba3" class="sup-faq-link"><span class="__cf_email__" data-cfemail="e3909693938c9197a38882979096948a8dcd828a">[email&nbsp;protected]</span></a>」までメールでご連絡ください。</span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">カスタマーサポートの対応時間は？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">勝WINでは、日本語対応のメール・ライブチャットを24時間365日ご利用いただけます。</span>
              </div>
            </div>
          </div>
        </div>
        <div id="faq-login" class="sup-faq-section">
          <p class="sup-faq-section-title">
            ログイン・アカウントについて
          </p>
          <div class="sup-faq-list">
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">ログインできません。どうすれば良いですか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">ご入力いただいたユーザー名とパスワードが正しいかを再度ご確認ください。<br>解決しない場合は、カスタマーサポートまでお問い合わせください。</span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">メールアドレスはどのように変更できますか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">「メールアドレス変更希望」と明記のうえ、以下の情報を「<a href="/cdn-cgi/l/email-protection#cdbeb8bdbda2bfb98da6acb9beb8baa4a3e3aca4" class="sup-faq-link"><span class="__cf_email__" data-cfemail="30434540405f4244705b5144434547595e1e5159">[email&nbsp;protected]</span></a>」までメールにてご連絡ください。<ul class="sup-faq-ul"><li>ユーザー名</li><li>氏名</li><li>変更理由</li><li>古いメールアドレス</li><li>新しいメールアドレス</li></ul></span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">パスワードは変更できますか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">はい、可能です。ログイン後に「アカウント認証」ページ内の「個人情報」欄にある「パスワード設定」から変更できます。</span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">パスワードを忘れた場合は、どうすれば良いですか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">ログイン画面の「パスワードをお忘れ」をクリックし、ユーザー名とメールアドレスを入力すると、パスワードを再設定できます。</span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">ユーザー名を忘れた場合は、どうすれば良いですか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">「ユーザー名を忘れた」と明記のうえ、以下の情報を「<a href="/cdn-cgi/l/email-protection#d3a0a6a3a3bca1a793b8b2a7a0a6a4babdfdb2ba" class="sup-faq-link"><span class="__cf_email__" data-cfemail="097a7c7979667b7d4962687d7a7c7e6067276860">[email&nbsp;protected]</span></a>」までメールにてご連絡ください。<ul class="sup-faq-ul"><li>氏名</li><li>メールアドレス</li><li>電話番号</li></ul></span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">ユーザー名を変更できますか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">ユーザー名は登録完了後に変更することはできません。</span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">メール配信を停止できますか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">はい、可能です。プロモーションメールの最下部にある「配信停止はこちら」からお手続きいただけます。また、「メール配信の停止希望」と明記のうえ、以下の情報を「<a href="/cdn-cgi/l/email-protection#3645434646594442765d57424543415f5818575f" class="sup-faq-link"><span class="__cf_email__" data-cfemail="becdcbceced1cccafed5dfcacdcbc9d7d090dfd7">[email&nbsp;protected]</span></a>」までメールにてご連絡ください。<ul class="sup-faq-ul"><li>ユーザー名</li><li>氏名</li><li>メールアドレス</li></ul></span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">アカウントを退会または凍結はできますか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">はい、可能です。「アカウント退会・凍結希望」と明記の上、以下の情報をカスタマーサポートまでメールまたはチャットにてご連絡ください。手続きが完了するとログインやメールの受信はできなくなります。<ul class="sup-faq-ul"><li>ユーザー名</li><li>氏名</li><li>メールアドレス</li></ul></span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">アカウントを削除できますか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">勝WINでは、お一人様につき1アカウントのみご利用いただけるため、アカウントの削除はできません。</span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">KYC（本人確認）に必要な書類は？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">KYC認証ページから以下2点をアップロードしてください。<ul class="sup-faq-ul"><li>身分証明書（運転免許証、パスポート、マイナンバーカードなど）</li><li>住所確認書類（住民票、公共料金請求書、クレジットカード請求書など）</li></ul>アップロードできない場合は「<a href="/cdn-cgi/l/email-protection#e4979194948b9690a48f85909791938d8aca858d" class="sup-faq-link"><span class="__cf_email__" data-cfemail="790a0c0909160b0d3912180d0a0c0e1017571810">[email&nbsp;protected]</span></a>」までメールでご送付ください。</span>
              </div>
            </div>
          </div>
        </div>
        <div id="faq-deposit" class="sup-faq-section">
          <p class="sup-faq-section-title">
            入金について
          </p>
          <div class="sup-faq-list">
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">どのような入金方法がありますか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">銀行振込、eウォレット、10種類以上の仮想通貨、クレジットカード、Apple Pay、Google Payなど、複数の入金方法に対応しています。</span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">1回あたりの入金額はいくらですか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">各入金方法ごとに最低入金額が異なります。詳しくは「入金ページ」に記載されていますので、ご利用前にご確認ください。</span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">入金にかかる時間はどれくらいですか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">eウォレットおよび仮想通貨での入金は、原則として即時〜10分以内に反映されます。銀行振込の場合は、通常5〜30分ほどで反映されます。</span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">入金時に手数料はかかりますか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">現在、入金時のサイト側の手数料はかかりません。ただし、銀行、ブロックチェーンネットワーク、または第三者の電子ウォレットなどにより別途手数料が発生する場合があります。</span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">入金時間に制限はありますか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">制限はございません。365日24時間いつでもご入金いただけます。</span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">入金ボーナスはどのように獲得できますか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">入金申請時にプロモーション選択欄が表示される場合は、ご希望のプロモーションを選択すると、自動的にボーナスを受け取れます。選択欄がないプロモーションについては、各プロモーションページ内の説明をご参照ください。</span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">入金ボーナスを申請するメリットは？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">入金ボーナスを受け取ることで、実際の入金額に加えて追加の資金が付与され、より多くの資金でプレイを始められます。</span>
              </div>
            </div>
          </div>
        </div>
        <div id="faq-withdraw" class="sup-faq-section">
          <p class="sup-faq-section-title">
            出金について
          </p>
          <div class="sup-faq-list">
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">どのような出金方法がありますか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">銀行振込、eウォレット、10種類以上の仮想通貨に対応しています。</span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">1回あたりの出金額はいくらですか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">出金方法ごとに以下のとおり異なります。<ul class="sup-faq-ul"><li>銀行振込：決済プロバイダーにより変動あり</li><li>VegaWallet：1,500円〜1,000,000円</li><li>Jetonbank：5,000円〜1,000,000円</li><li>仮想通貨：3,000円相当〜3,000,000円相当</li></ul></span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">1日の最大出金額はいくらですか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">1日の最大出金額に制限はございませんが、1回あたりの出金は最大3,000,000円までとなります。</span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">出金にかかる時間はどれくらいですか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">通常は数分〜15分ほどで出金が完了します。ただし、決済プロバイダーやブロックチェーンの混雑状況によっては、処理に時間がかかる場合があります。</span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">出金時に手数料はかかりますか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">現在、出金時のサイト側の手数料はかかりません。ただし、銀行、ブロックチェーンネットワーク、または第三者の電子ウォレットなどにより別途手数料が発生する場合があります。</span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">出金時間に制限はありますか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">制限はございません。365日24時間対応しています。</span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">入金後すぐに出金できますか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">マネーロンダリングなどの不正送金防止のため、入金直後の出金はできません。ゲーム結果に関わらず、入金額の「2倍」をベットいただく必要があります。この条件を満たした上で、出金が可能となります。</span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">毎回出金のたびに身分証を提出する必要はありますか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">初回出金時にKYC（本人確認）の手続きを完了していれば、2回目以降の出金時に再度KYC（本人確認）を行う必要はありません。</span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">出金は入金と同じ方法で行う必要がありますか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">はい、原則として入金と同じ方法での出金が必要です。また、USDT購入によるご入金の場合は、仮想通貨での出金が可能です。</span>
              </div>
            </div>
          </div>
        </div>
        <div id="faq-game" class="sup-faq-section">
          <p class="sup-faq-section-title">
            ゲームについて
          </p>
          <div class="sup-faq-list">
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">どのようなカジノゲームがありますか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">パチンコ・パチスロをはじめ、スロット、バカラ、ブラックジャック、ルーレットなど、8,000種類以上のゲームをお楽しみいただけます。</span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">オンラインライブ＆テーブルの利点は何ですか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">ライブ＆テーブルでは、コンピューターの乱数ではなく、実際のディーラーがゲームを進行します。これにより、公平性・信頼性が高まり、HD映像による臨場感あふれるプレイをお楽しみいただけます。また、バカラ・ルーレット・ブラックジャックなどのクラシックなカジノゲームを幅広くご用意しており、ご自宅からでも24時間いつでも本格的なカジノ体験を味わうことができます。</span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">ゲームの公平性は保証されていますか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">はい。勝WINのゲームは高度な技術に基づいて構築されており、公平性を確保しています。ライブゲームでは、専門的な訓練を受けたディーラーのみが進行を担当し、結果はすべてゲームプロバイダーによって監視されています。さらに、全てのゲームで乱数発生装置（RNG）を用いて乱数を生成し、公平なプレイが保証されています。</span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">各ゲームの最低ベット額はいくらですか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">ゲームによって異なります。各ゲーム内でご確認ください。</span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">スロットの遊び方は？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">スロットは、リールを回転させてペイライン上にシンボルが揃うと賞金を獲得できるシンプルで楽しいゲームです。各ゲームには独自のボーナス機能やサウンド、ライトエフェクトがあり、エンターテイメント性も魅力です。<br><br>※遊び方の流れ：<ol class="sup-faq-ol"><li>【スロットを選ぶ】テーマ、演出、ペイアウトルールなどがゲームごとに異なります。気になるスロットを選んでください。</li><li>【ベット額を設定する】多くのスロットでは、1回ごとのベット額を自由に設定できます。ご予算に合わせて金額を調整しましょう。</li><li>【スピンを開始する】回転ボタンを押すとリールが回り、サウンドや演出とともに結果が表示されます。シンボルが揃えば配当獲得です。</li></ol></span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">ライブ＆テーブルゲームの遊び方は？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">ライブ＆テーブルでは、プロのディーラーとリアルタイムで対戦できる臨場感あふれるカジノ体験をお楽しみいただけます。HD映像で配信されるライブテーブルに参加し、ご自身の画面から操作するだけでゲームに参加可能です。<br><br>※プレイできる主なゲーム：<ul class="sup-faq-ul"><li>バカラ</li><li>ブラックジャック</li><li>ルーレット</li></ul>各ゲームにはルールや進行方法がありますが、基本的には画面上でベットを行い、ディーラーの進行に従って結果を確認します。シンプルな操作で、24時間いつでも本格的なカジノを体験できます。</span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">パチンコ・パチスロの遊び方は？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">パチンコ・パチスロはシンプルなルールで、初心者の方でもすぐにお楽しみいただけます。<br><br>※遊び方の流れ：<ol class="sup-faq-ol"><li>【台を選ぶ】テーマや演出、機能が異なる台からお好きなものを選びます。</li><li>【ベットを設定する】遊技に使用する金額を設定してください。ご予算に合わせて調整してください。</li><li>【スタートボタンを押す】パチンコなら玉を打ち出し、パチスロならリールが回転します。</li><li>【結果を確認する】リールのシンボルが揃ったり、特定の条件を満たすと当たりが発生し、払い出しやボーナスを獲得できます。</li></ol>各台には独自の演出やボーナス機能が搭載されており、音や光の演出も含めて臨場感を楽しめるのが魅力です。</span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">プレイ記録はどこで確認できますか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">アカウント内の「ゲーム履歴」から確認できます。</span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">ゲームが開けません。どうすれば良いですか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">以下をお試しください。<ol class="sup-faq-ol"><li>ブラウザのキャッシュ・クッキーを削除</li><li>他のブラウザで起動（Chrome推奨）</li><li>デバイスのOSやブラウザを最新に更新</li><li>再起動後に再試行</li></ol>解決しない場合はスクリーンショットを添付し、サポートへご連絡ください。</span>
              </div>
            </div>
          </div>
        </div>
        <div id="faq-crypto" class="sup-faq-section">
          <p class="sup-faq-section-title">
            仮想通貨について
          </p>
          <div class="sup-faq-list">
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">仮想通貨とは何ですか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">仮想通貨とは、インターネット上で取引されるデジタル資産であり、ブロックチェーン技術を基盤として発行・管理されています。中央銀行が発行する法定通貨とは異なり、分散型ネットワーク上で管理されるため、迅速かつ低コストでの送金や取引が可能です。勝WINでは、10種類以上の仮想通貨で入出金に対応しています。</span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">どの仮想通貨に対応していますか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">勝WINでは、以下の仮想通貨での入出金に対応しております：<br>USDT（テザー）、LTC（ライトコイン）、XRP（リップル）、BTC（ビットコイン）、ETH（イーサリアム）、DOGE（ドージコイン）、BCH（ビットコインキャッシュ）、TRX（トロン）、BNB（バイナンスコイン）、USDC（USDコイン）、SHIB（シバイヌ）、TETH（テセリウム）</span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">仮想通貨の入出金にかかる時間は？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">通常、数分〜10分ほどで入出金が完了いたします。ただし、ブロックチェーンの混雑状況によりネットワークの確認に時間を要する場合がございます。</span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">仮想通貨での入出金にはKYC（本人確認）は必要ですか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">はい、ご出金前には、KYC（本人確認書類）のアップロードおよび審査の完了が必要です。KYC（本人確認）が完了していない場合は、出金をご利用いただけませんので、あらかじめご了承ください。</span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">仮想通貨の入出金に手数料はかかりますか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">サイト側での手数料はかかりません。ただし、ブロックチェーンのガス代の送金手数料が発生する場合がございます。</span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">ウォレット内で仮想通貨の交換はできますか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">仮想通貨ウォレット間の資金移動は、ウォレット振替機能をご利用いただくことで可能です。ただし、仮想通貨からJPYウォレットへの交換・振替には対応しておりません。</span>
              </div>
            </div>
            <div class="sup-faq-item">
              <div class="sup-faq-q">
                <span class="sup-faq-label">Q.</span><span class="sup-faq-text">セキュリティ対策は大丈夫ですか？</span>
              </div>
              <div class="sup-faq-a">
                <span class="sup-faq-label">A.</span><span class="sup-faq-text">勝WINでは、アカウントの安全性を高めるために、2段階認証（2FA）を導入しています。ユーザー名とパスワードに加えて、ワンタイムコードによる認証を組み合わせることで、不正アクセスを防止し、セキュリティを強化しています。</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'
import supMenu from '@/views/page/sup/supMenu'
export default {
  name: 'FaqGold',
  components: {
    goToTop,
    supMenu
  },
  data() {
    return {
    }
  },
  computed: {
    supportEmail() {
      return process.env.VUE_APP_SUPPORT_EMAIL
    }
  },
  created() {
  },
  methods: {
    scrollTo(id) {
      setTimeout(() => {
        const element = document.getElementById(id)
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' })
        }
      }, 10)
    }
  }
}
</script>
